<template>
    <v-card class="ma-2 time-card">
        <v-card-text>
            <div class="recording-title">Vacation</div>
            <v-flex class="mb-2" xs12>Vacation days left: {{LeftVacationsDays}}</v-flex>
            <v-divider class="mb-3"></v-divider>
            <v-form v-model="formValid" ref="form" lazy-validation novalidate>
                <v-layout align-center>
                    <v-flex xs1>
                        <div class="mx-3">
                            <v-btn flat color="black" disabled class="add-vacation-btn">
                                {{getVacationDuration(this.vacationStartDate, this.vacationEndDate)}}
                            </v-btn>
                        </div>
                    </v-flex>
                    <v-flex xs2>
                        <div class="mx-3">
                            <v-menu :disabled="isEmployeeArchived || isNoDaysLeft" lazy transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px">
                                <v-text-field :rules="dateRules" required class="vacation-date" slot="activator" label="Period start" v-model="vacationStartEmploymentPeriodDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="vacationStartEmploymentPeriodDate" no-title scrollable actions>
                                </v-date-picker>
                            </v-menu>
                        </div>
                    </v-flex>
                    <v-flex xs2>
                        <div class="mx-3">
                            <v-menu :disabled="isEmployeeArchived || isNoDaysLeft" lazy transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px">
                                <v-text-field :rules="dateRules" required class="vacation-date" slot="activator" label="Period end" v-model="vacationEndEmploymentPeriodDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="vacationEndEmploymentPeriodDate" :allowed-dates="employmentPeriodAllowedDays" no-title scrollable actions>
                                </v-date-picker>
                            </v-menu>
                        </div>
                    </v-flex>
                    <v-flex xs2>
                        <div class="mx-3">
                            <v-menu :disabled="isEmployeeArchived || isNoDaysLeft" lazy transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px">
                                <v-text-field :rules="dateRules" required class="vacation-date" slot="activator" label="Start date" v-model="vacationStartDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="vacationStartDate" no-title scrollable actions>
                                </v-date-picker>
                            </v-menu>
                        </div>
                    </v-flex>
                    <v-flex xs2>
                        <div class="mx-3">
                            <v-menu :disabled="isEmployeeArchived || isNoDaysLeft" lazy transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px">
                                <v-text-field :rules="dateRules" required class="vacation-date" slot="activator" label="End date" v-model="vacationEndDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="vacationEndDate" :allowed-dates="vacationAllowedDays" no-title scrollable actions>
                                </v-date-picker>
                            </v-menu>
                        </div>
                    </v-flex>
                    <v-flex xs2>
                        <div class="mx-3">
                            <v-text-field :disabled="isEmployeeArchived || isNoDaysLeft" v-model="vacationOrderNumber" label="№ of Order" 
                                required :rules="orderRule"></v-text-field>
                        </div>
                    </v-flex>
                    <v-flex xs2>
                        <div class="mx-3">
                            <v-menu :disabled="isEmployeeArchived || isNoDaysLeft" lazy transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px">
                                <v-text-field :rules="dateRules" required class="vacation-date" slot="activator" label="Order date" v-model="vacationOrderDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="vacationOrderDate" no-title scrollable actions>
                                </v-date-picker>
                            </v-menu>
                        </div>
                    </v-flex>
                    <v-flex class="text-xs-center" xs1>
                        <v-btn :disabled="isEmployeeArchived || isNoDaysLeft" flat color="black" @click.stop.prevent="addNewVacation()" slot="activator" class="add-vacation-btn">
                            <v-icon color="indigo">mdi-plus</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-form>
            <template v-for="vacation in vacations">
                <v-divider :key="`divider-${vacation.id ? `id${vacation.id}` : `obsId${vacation.observationId}`}`" class="mb-3"></v-divider>
                <v-layout :key="`layout-${vacation.id ? `id${vacation.id}` : `obsId${vacation.observationId}`}`" align-center>
                    <v-flex xs1>
                        <div class="mx-3">
                            <v-btn flat color="black" disabled class="add-vacation-btn">
                                {{getVacationDuration(vacation.startDate, vacation.endDate)}}
                            </v-btn>
                        </div>
                    </v-flex>
                    <v-flex xs2>
                        <div class="mx-3">
                            <v-menu :disabled="isEmployeeArchived" lazy transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px">
                                <v-text-field required class="vacation-date" slot="activator" label="Period Start" v-model="vacation.startEmploymentPeriodDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="vacation.startEmploymentPeriodDate" no-title scrollable actions>
                                </v-date-picker>
                            </v-menu>
                        </div>
                    </v-flex>
                    <v-flex xs2>
                        <div class="mx-3">
                            <v-menu :disabled="isEmployeeArchived" lazy transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px">
                                <v-text-field required class="vacation-date" slot="activator" label="Period End" v-model="vacation.endEmploymentPeriodDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="vacation.endEmploymentPeriodDate" no-title scrollable actions>
                                </v-date-picker>
                            </v-menu>
                        </div>
                    </v-flex>
                    <v-flex xs2>
                        <div class="mx-3">
                            <v-menu :disabled="isEmployeeArchived" lazy transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px">
                                <v-text-field :rules="dateRules" required class="vacation-date" slot="activator" label="Start date" v-model="vacation.startDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="vacation.startDate" no-title scrollable actions>
                                </v-date-picker>
                            </v-menu>
                        </div>
                    </v-flex>
                    <v-flex xs2>
                        <div class="mx-3">
                            <v-menu :disabled="isEmployeeArchived" lazy transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px">
                                <v-text-field :rules="dateRules" required class="vacation-date" slot="activator" label="End date" v-model="vacation.endDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="vacation.endDate" no-title scrollable actions>
                                </v-date-picker>
                            </v-menu>
                        </div>
                    </v-flex>
                    <v-flex xs2>
                        <div class="mx-3">
                            <v-text-field label="№ of Order" v-model="vacation.orderNumber" required :rules="orderRule"></v-text-field>
                        </div>
                    </v-flex>
                    <v-flex xs2>
                        <div class="mx-3">
                            <v-menu :disabled="isEmployeeArchived || isNoDaysLeft" lazy transition="scale-transition" offset-y full-width :nudge-right="40" :close-on-content-click="false" max-width="290px" min-width="290px">
                                <v-text-field :rules="dateRules" required class="vacation-date" slot="activator" label="Order date" v-model="vacation.orderDate" prepend-icon="event" readonly></v-text-field>
                                <v-date-picker v-model="vacation.orderDate" no-title scrollable actions>
                                </v-date-picker>
                            </v-menu>
                        </div>
                    </v-flex>
                    <v-flex class="text-xs-center" xs1>
                        <v-btn :disabled="isEmployeeArchived" flat color="black" @click="removeExistVacation(vacation)" slot="activator" class="add-vacation-btn">
                            <v-icon color="indigo">mdi-delete</v-icon>
                        </v-btn>     
                        <v-btn :disabled="isEmployeeArchived" flat color="black" @click="editExistVacation(vacation)" slot="activator" class="add-vacation-btn">
                            <v-icon color="indigo">mdi-content-save</v-icon>
                        </v-btn>                          
                    </v-flex>
                </v-layout>
            </template>
        </v-card-text>
    </v-card>
</template>

<script>
    import moment from 'moment';
    import {
        mapGetters, mapActions
    } from 'vuex';

    export default {
        name: 'EmployeeVacation',
        data() {
            return {
                vacationStartDate: null,
                vacationEndDate: null,
                vacationStartEmploymentPeriodDate: null,
                vacationEndEmploymentPeriodDate: null,
                vacationOrderDate: null,
                vacationOrderNumber: null,
                formValid: false,
                dateRules: [ value => !!value || 'Choose date' ],
                selectRules: [ value => !!value || 'Choose option' ],
                orderRule: [ order => (order && !!order.trim()) || 'Enter number of vacation order' ],
                leftVacationDays: 0,
                observationId: 0
            };
        },
        computed: {
            ...mapGetters({
                employee: 'getEmployee',
                vacations: 'getAllVacations',
                vacationDays: 'getUserVacationDays',
                holidays: 'getHolidays'
            }),
            LeftVacationsDays: {
                get() {
                    let leftDays = this.vacationDays;
                    if (this.vacations.length) {
                        let takenVacationDays = 0;
                        this.vacations.forEach(vacation => {
                            takenVacationDays += this.getVacationDuration(vacation.startDate, vacation.endDate);
                        });
                        leftDays -= takenVacationDays;
                    }
                    return leftDays;
                },
                set(value) {
                    this.leftVacationDays = value;
                }
            },
            isEmployeeArchived() {
                return this.employee.archived;
            },
            isNoDaysLeft() {
                return this.LeftVacationsDays === 0;
            }
        },
        methods: {
            ...mapActions([
                'addVacation',
                'editVacation',
                'removeVacation'
            ]),
            addNewVacation() {
                if (this.$refs.form.validate()) {
                    const vacation = {
                        observationId: this.observationId++,
                        startDate: this.vacationStartDate,
                        endDate: this.vacationEndDate,
                        startEmploymentPeriodDate: this.vacationStartEmploymentPeriodDate,
                        endEmploymentPeriodDate: this.vacationEndEmploymentPeriodDate,
                        orderNumber: this.vacationOrderNumber,
                        user: {
                            userId: this.employee.userId
                        },
                        orderDate: this.vacationOrderDate
                    };

                    const vacationDuration = this.getVacationDuration(this.vacationStartDate, this.vacationEndDate);
                    this.LeftVacationsDays -= vacationDuration;

                    this.addVacation(vacation).then(() => {
                        this.$refs.form.reset();
                    });
                }
            },
            removeExistVacation(vacation) {
                this.removeVacation(vacation).then(() => {
                    const vacationDuration = this.getVacationDuration(vacation.startDate, vacation.endDate);
                    this.LeftVacationsDays += vacationDuration;
                });
            },
            editExistVacation(vacation) {
                this.editVacation(vacation);
            },
            vacationAllowedDays(date) {
                return moment(date).isSameOrAfter(moment(this.vacationStartDate)) &&
                    moment(date).isBefore(moment(this.vacationStartDate).add(this.LeftVacationsDays, 'days'));
            },
            employmentPeriodAllowedDays(date) {
                return moment(date).isSameOrAfter(moment(this.vacationStartEmploymentPeriodDate));
            },
            getVacationDuration(startDate, endDate) {
                const dates = this.getDatesInRange(startDate, endDate);
                let duration = 0;
                dates.forEach(date => {
                    if (!this.holidays.some(holiday => holiday.name.isSame(date))) {
                        duration++;
                    }
                });
                return duration;
            },
            getDatesInRange(startDate, endDate) {
                let dates = [];
                let currentDate = moment(startDate);
                const stopDate = moment(endDate);
                while (currentDate <= stopDate) {
                    dates.push(moment(currentDate));
                    currentDate = moment(currentDate).add(1, 'days');
                }
                return dates;
            }
        }
    };
</script>

<style scoped>
.recording-title {
  font-size: 20px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.add-vacation-btn >>> .btn__content {
  padding: 0;
}

.add-vacation-btn {
  min-width: 32px;
  width: 32px;
  min-height: 32px;
  height: 32px;
  margin: 6px 0px 14px 6px;
  background-color: #ced2e6 !important;
  font-size: 18px;
}

.vacation-date >>> .input-group__input input {
  font-size: 14px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/reusable/EmployeeVacation.vue